<irembogov-generic-button
  [formControl]="formControl"
  [id]="field.key"
  [buttonText]="field.props['buttonText']"
  [buttonStyle]="field.props['buttonStyle']"
  [width]="field.props['width']"
  [alignment]="field.props['alignment']"
  [statusClass]="statusClass"
  [disabled]="field.props['disabled'] ?? false"
  (buttonClick)="onButtonClick()">
</irembogov-generic-button>

<!-- Success Message Display -->
<div *ngIf="successMessage" class="mt-2">
  <span style="color: #28a745; font-size: 0.875rem; font-weight: 500">
    {{ successMessage | translate }}
  </span>
</div>
